<template>
  <div>
    <v-row>
      <v-col cols="12" md="6" lg="4">
        <v-card class="elevation-12">
          <v-card-title>
            <v-btn color="primary" text :to="{name: 'moderator-organizations'}">{{ $t('moderatorDashboard.cards.organizations') }}</v-btn>
          </v-card-title>
        </v-card>
      </v-col>

      <v-col cols="12" md="6" lg="4" v-if="isModeratorUnitIsHead">
        <v-card class="elevation-12">
          <v-card-title>
            <v-btn color="primary" text :to="{name: 'moderator-users'}">{{ $t('moderatorDashboard.cards.users') }}</v-btn>
          </v-card-title>
        </v-card>
      </v-col>

      <v-col cols="12" md="6" lg="4">
        <v-card class="elevation-12">
          <v-card-title>
            <v-btn color="primary" text :to="{name: 'moderator-units'}">{{ $t('moderatorDashboard.cards.departments') }}</v-btn>
          </v-card-title>
        </v-card>
      </v-col>

      <v-col cols="12" md="6" lg="4">
        <v-card class="elevation-12">
          <v-card-title>
            <v-btn color="primary" text :to="{name: 'moderator-mails'}">{{ $t('moderatorDashboard.cards.mails') }}</v-btn>
          </v-card-title>
        </v-card>
      </v-col>

      <v-col cols="12" md="6" lg="4">
        <v-card class="elevation-12">
          <v-card-title>
            <v-btn color="primary" text :to="{name: 'moderator-statistics-dashboard-page'}">{{ $t('moderatorDashboard.cards.statistics') }}</v-btn>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {LAYOUT_TITLE_CHANGED} from "@/store/modules/layout/actions";
import {Moderator} from "@/enums/user.type";

export default {
  name: "ModeratorDashboardPage",
  computed: {
    isModeratorUnitIsHead() {
      return this.$store.getters.appIsInitialized && this.$store.getters.appLogin?.type === Moderator && this.$store.getters.appLogin.globalunit.isHead;
    }
  },
  created() {
    this.$store.dispatch(LAYOUT_TITLE_CHANGED, this.$t('moderatorDashboard.pageTitle'))
  }
}
</script>

<style scoped>

</style>